import { css } from 'lit'

export default css`
    input[type='radio'] {
        height: 1.28em;
        margin-right: 0.57rem;
        width: 1.28em;
    }

    .container {
        margin-top: 8px;
        display: flex;
        align-items: flex-start;
        font-weight: var(--font-weight-medium);
        cursor: pointer;
        align-items: center;
    }

    @media only screen and (max-width: 768px) {
        .container {
            min-height: 48px;
        }
    }

    .container:hover {
        background-color: var(--darkerCloudGrey);
    }
    .description {
        flex: 1;
    }
    .title {
        color: var(--grey1);
        line-height: 1.37em;
        opacity: 0.8;
    }
    .detail {
        color: var(--grey3);
        line-height: 17px;
        opacity: 0.8;
    }
`
